import {
  Stack,
  Affix,
  Paper,
  Drawer,
  ActionIcon,
  Group,
  MantineSpacing,
  getDefaultZIndex,
} from '@mantine/core';
import IconChevronLeft from '@tabler/icons-react/dist/esm/icons/IconChevronLeft.mjs';
import IconChevronRight from '@tabler/icons-react/dist/esm/icons/IconChevronRight.mjs';
import { ReactNode } from 'react';

interface Props {
  children?: ReactNode;
  opened: boolean;
  onChange: (value: boolean) => void;
  rightSection?: ReactNode;
  top?: number;
  left?: number;
  p?: MantineSpacing;
  pt?: MantineSpacing;
  ps?: MantineSpacing;
  pb?: MantineSpacing;
  pe?: MantineSpacing;
}
export const ViewMenuPanel = ({
  children,
  opened,
  onChange,
  rightSection,
  top = 0,
  left = 0,
  ...paddingProps
}: Props) => {
  return (
    <>
      <Affix
        {...paddingProps}
        position={{ top, left }}
        withinPortal={false}
        component={Stack}
        className='!absolute flex flex-col min-h-0'
        zIndex={100}
      >
        {!opened && (
          <Group>
            <ActionIcon
              data-testid='show-view-settings-btn'
              onClick={() => onChange(true)}
              variant='light'
            >
              <IconChevronRight />
            </ActionIcon>
            {rightSection}
          </Group>
        )}
      </Affix>

      <Drawer.Root
        position={'left'}
        size={350}
        // Ниже плавающих окон КЕ (z < modal) и модалок, выше канваса и контролов.
        zIndex={getDefaultZIndex('app')}
        data-testid='view-menu-panel-drawer'
        classNames={{
          // overlay: '!absolute',
          inner: '!absolute',
          body: `!h-full !overflow-hidden`,
          content: '!overflow-visible !shadow-none',
        }}
        radius={'sm'}
        withinPortal={false}
        opened={opened}
        onClose={() => {
          onChange(false);
        }}
        keepMounted
        // Monitoring subscriptions must stay active while the panel is closed.
        keepMountedMode='display-none'
        trapFocus={false}
        lockScroll={false}
      >
        <Drawer.Content {...paddingProps}>
          <Group
            className='absolute'
            wrap='nowrap'
            style={{
              right: `calc(var(--mantine-spacing-sm) * -1)`,
              transform: 'translateX(100%)',
            }}
            gap={'sm'}
          >
            <ActionIcon
              data-testid='hide-view-settings-btn'
              onClick={() => onChange(!opened)}
              variant='default'
            >
              <IconChevronLeft />
            </ActionIcon>
            {rightSection}
          </Group>

          <Paper withBorder className={'h-full overflow-hidden'}>
            <Drawer.Body>{children}</Drawer.Body>
          </Paper>
        </Drawer.Content>
      </Drawer.Root>
    </>
  );
};